import { Select, SelectItem, SelectProps } from 'zens-storybook'
import React from 'react'
import { StyleSheet } from 'react-native'
import { useFloors, useBuildings } from 'zens-store'
import { Href } from 'zens-router'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends Omit<SelectProps<number | number[]>, 'items' | 'onSelect'> {
  companyId: number
  buildingId?: number
  floorIds?: number[]
  onChange?: (value: number | number[]) => void
  extraItems?: SelectItem<number>[]
  groupBuilding?: boolean
  href?: (buildingId: number) => Href
}

const FloorSelect = (props: Props) => {
  const { onChange, companyId, buildingId, floorIds, value, extraItems, groupBuilding, href, ...otherProps } = props
  const floors = useFloors({ companyId, buildingId })
  const buildings = useBuildings({ companyId: groupBuilding ? companyId : 0 })
  const availableFloors = floors.data?.filter((floor) => !floorIds || floorIds.includes(floor.id))
  const items = [
    ...(extraItems || []),
    ...((groupBuilding
      ? buildings.data
          ?.filter((building) => !floorIds || availableFloors?.some((floor) => floor.buildingId === building.id))
          .sort((a, b) => a.name?.localeCompare(b.name || '') || 0)
          .map((building) => ({
            title: building.name,
            value: building.id,
            items: availableFloors
              ?.filter((floor) => floor.buildingId === building.id)
              ?.sort((a, b) => {
                const sortNumber = (a?.number || 0) - (b?.number || 0)
                if (sortNumber) return sortNumber
                return a?.displayName?.localeCompare(b?.displayName)
              })
              .map((floor) => ({
                value: floor.id,
                title: floor.displayName,
                href: href?.(floor.id),
              })),
          }))
      : availableFloors
          ?.sort((a, b) => {
            const sortNumber = (a?.number || 0) - (b?.number || 0)
            if (sortNumber) return sortNumber
            return a?.displayName?.localeCompare(b?.displayName)
          })
          ?.map((floor) => ({
            value: floor.id,
            title: floor.displayName,
            href: href?.(floor.id),
          }))) || []),
  ]
  return (
    <Select
      style={styles.container}
      onSelect={onChange}
      items={items}
      testID="FloorSelect.Container"
      value={value}
      {...otherProps}
    />
  )
}

export default FloorSelect
